// extracted by mini-css-extract-plugin
export default {"head":"PolicyList_head__jf47b","Subhead":"PolicyList_Subhead__EQTfX","list":"PolicyList_list__RHBgc","subList":"PolicyList_subList__NK+Tl"};